import React from "react";
const Load = () =>{
    return (
        <div className="loader-wrapper">
            <div className="loader"></div>
        </div>
    )
}
export default Load;